/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PerplayStatisticsControllerDtoNftCarRequest model module.
 * @module model/PerplayStatisticsControllerDtoNftCarRequest
 * @version 1.0
 */
class PerplayStatisticsControllerDtoNftCarRequest {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoNftCarRequest</code>.
     * @alias module:model/PerplayStatisticsControllerDtoNftCarRequest
     */
    constructor() { 
        
        PerplayStatisticsControllerDtoNftCarRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoNftCarRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoNftCarRequest} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoNftCarRequest} The populated <code>PerplayStatisticsControllerDtoNftCarRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoNftCarRequest();

            if (data.hasOwnProperty('nftType')) {
                obj['nftType'] = ApiClient.convertToType(data['nftType'], 'Number');
            }
            if (data.hasOwnProperty('nftGrade')) {
                obj['nftGrade'] = ApiClient.convertToType(data['nftGrade'], 'String');
            }
            if (data.hasOwnProperty('nftSeal')) {
                obj['nftSeal'] = ApiClient.convertToType(data['nftSeal'], 'String');
            }
            if (data.hasOwnProperty('isPlus')) {
                obj['isPlus'] = ApiClient.convertToType(data['isPlus'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoNftCarRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoNftCarRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['nftGrade'] && !(typeof data['nftGrade'] === 'string' || data['nftGrade'] instanceof String)) {
            throw new Error("Expected the field `nftGrade` to be a primitive type in the JSON string but got " + data['nftGrade']);
        }
        // ensure the json data is a string
        if (data['nftSeal'] && !(typeof data['nftSeal'] === 'string' || data['nftSeal'] instanceof String)) {
            throw new Error("Expected the field `nftSeal` to be a primitive type in the JSON string but got " + data['nftSeal']);
        }

        return true;
    }


}



/**
 * @member {Number} nftType
 */
PerplayStatisticsControllerDtoNftCarRequest.prototype['nftType'] = undefined;

/**
 * @member {String} nftGrade
 */
PerplayStatisticsControllerDtoNftCarRequest.prototype['nftGrade'] = undefined;

/**
 * @member {String} nftSeal
 */
PerplayStatisticsControllerDtoNftCarRequest.prototype['nftSeal'] = undefined;

/**
 * @member {Boolean} isPlus
 */
PerplayStatisticsControllerDtoNftCarRequest.prototype['isPlus'] = undefined;






export default PerplayStatisticsControllerDtoNftCarRequest;

